import { render, staticRenderFns } from "./InputResetPassword.vue?vue&type=template&id=641820e4&scoped=true"
import script from "./InputResetPassword.vue?vue&type=script&lang=js"
export * from "./InputResetPassword.vue?vue&type=script&lang=js"
import style0 from "./InputResetPassword.vue?vue&type=style&index=0&id=641820e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641820e4",
  null
  
)

export default component.exports